<template>
  <div v-if="!isFooterOnly">
    <form @submit.prevent="handleSubmit">
      <div class="field">
        <label class="label">Due Date *</label>
        <div class="control">
          <input
            type="datetime-local"
            class="input"
            v-model="dueDateLocal"
            required
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Currency *</label>
        <div class="control">
          <div class="select">
            <select v-model="form.currency" required>
              <option value="">Select Currency</option>
              <option value="USD">USD</option>
              <option value="TL">TL</option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Amount *</label>
        <div class="control">
          <input
            type="number"
            step="0.01"
            class="input"
            v-model.number="form.amount"
            required
          />
        </div>
      </div>

      <div class="field">
        <p class="help">* Required fields</p>
      </div>
    </form>
  </div>

  <div v-else class="buttons">
    <button class="button" @click="closeModal">Cancel</button>
    <button class="button is-primary" @click="triggerSubmit">
      Create Invoice
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { httpInstance as http } from "@/plugins/http";
import toast from "@/utils/toast";

export default {
  name: "ModalAddInvoice",
  props: {
    modalData: {
      type: Object,
      default: () => ({}),
    },
    modalIndex: {
      type: Number,
      required: true,
    },
    isFooterOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const oneWeekLater = new Date();
    oneWeekLater.setDate(oneWeekLater.getDate() + 7);

    const formatDateForBackend = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}T00:00:00Z`;
    };

    return {
      form: {
        due_date: formatDateForBackend(oneWeekLater),
        currency: "USD",
        amount: null,
        contract_id: null,
      },
    };
  },
  computed: {
    dueDateLocal: {
      get() {
        return this.formatToLocal(this.form.due_date);
      },
      set(value) {
        this.form.due_date = this.formatToBackend(value);
      },
    },
  },
  methods: {
    ...mapActions(["closeTopModal"]),
    closeModal() {
      this.closeTopModal();
    },
    triggerSubmit() {
      this.$root.$emit("add-invoice-submit");
    },
    formatToLocal(backendDate) {
      if (!backendDate) return "";
      return backendDate.slice(0, -4);
    },
    formatToBackend(localDate) {
      if (!localDate) return "";
      return localDate + ":00Z";
    },
    async handleSubmit() {
      try {
        if (
          !this.form.due_date ||
          !this.form.currency ||
          !this.form.amount ||
          !this.form.contract_id
        ) {
          toast.error("Please fill all required fields");
          return;
        }

        const formData = new FormData();
        Object.keys(this.form).forEach((key) => {
          formData.append(key, this.form[key]);
        });

        const response = await http.post("invoices", formData);

        if (response.status === 200) {
          toast.success("Invoice created successfully");
          this.closeModal();
          this.$root.$emit("invoice-created");
        }
      } catch (error) {
        console.error("Error creating invoice:", error);
        toast.error("Error creating invoice");
      }
    },
    initializeForm() {
      if (this.modalData && this.modalData.contract_id) {
        this.form.contract_id = this.modalData.contract_id;
      }
    },
  },
  watch: {
    modalData: {
      handler() {
        this.initializeForm();
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeForm();

    if (!this.isFooterOnly) {
      this.$root.$on("add-invoice-submit", this.handleSubmit);
    }
  },
  beforeDestroy() {
    if (!this.isFooterOnly) {
      this.$root.$off("add-invoice-submit", this.handleSubmit);
    }
  },
};
</script>

<style scoped>
.buttons {
  justify-content: flex-end;
}
</style>
